import { Box } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

export const QuotingText: FC<PropsWithChildren> = ({ children }) => {
    return (
        <Box
            sx={{
                p: 1,
                pl: 2,
                borderLeft: '3px solid #BDBFC7',
                margin: 0,
                mb: 2,
                '> p': {
                    color: '#9195A1',
                    mb: 0,
                },
            }}>
            {children}
        </Box>
    )
}
